import * as React from "react";
import { Modal } from "carbon-components-react";
import { AppShape, DocShape } from "@eave/shared/types/api";
import DocChangerModule from "./DocChangerModule";

const styles = require("./docUploaderStyles.module.scss");

interface DocChangerProps {
  app: AppShape;
  onHide: Function;
  onSave: Function;
  documents: [DocShape];
  ownerOptions: any;
}

class DocChanger extends React.Component<DocChangerProps, any> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { app, onHide, onSave, ownerOptions, documents } = this.props;
    return (
      <Modal
        open
        className={styles.changerModal}
        modalHeading="Change doc info"
        passiveModal // no footer, no buttons
        selectorPrimaryFocus="#borrower-name"
        onRequestClose={onHide}
        onBlur={onHide}
      >
        <div>
          {documents.map(doc => (
            <DocChangerModule
              app={app}
              key={doc.id}
              doc={doc}
              hideButton={false}
              ownerOptions={ownerOptions}
              onSave={onSave}
            />
          ))}
        </div>
      </Modal>
    );
  }
}

export default DocChanger;
